module.exports = __webpack_public_path__ + "static/media/arrow_right_blue.fb590aea.svg";